// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"8919b11d","952":"cde6ea04"}[chunkId] + ".chunk.js";
};